import{classCallCheck as l}from"../_virtual/_rollupPluginBabelHelpers.js";var r=function r(s){l(this,r);this.model=s};export{r as HierarchyLayoutStage};
